import apiClient from '../authentication/utils/core/axios';

/**
 * FeatureFlagsAPI — public read (used app-wide to gate UI/routes) + admin CRUD
 * (used by the admin panel's Feature Flags tab) against the DB-backed flags
 * that replaced the previous hardcoded `redux/featureFlags.js` object.
 *
 * `name` is the unique flag identifier (e.g. "posts") -- matches the pre-existing
 * `FeatureFlag` model (backend_stocker/APP/models/admin_models/admin_models.py),
 * which was already migrated but never wired to a CRUD/endpoint until this pass.
 */
const FeatureFlagsAPI = {
  /** Public: {name: enabled} map. No auth required -- gates nav/routing before
   *  an authenticated session necessarily exists. */
  fetchFlags: async () => {
    const res = await apiClient.get('/feature-flags');
    return res.data;
  },

  /** Admin: full flag objects (id, name, description, enabled, created_by, timestamps). */
  fetchFlagsAdmin: async () => {
    const res = await apiClient.get('/admin/feature-flags/');
    return res.data;
  },

  createFlag: async (flagData) => {
    const res = await apiClient.post('/admin/feature-flags/', flagData);
    return res.data;
  },

  updateFlag: async (name, updates) => {
    const res = await apiClient.patch(`/admin/feature-flags/${name}`, updates);
    return res.data;
  },

  deleteFlag: async (name) => {
    await apiClient.delete(`/admin/feature-flags/${name}`);
    return name;
  },
};

export default FeatureFlagsAPI;
